import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, darkGrayFontColor, header, success } from '../../../../web/styles/colors';
import { BreakPoints, CssSelectors, DefaultBorder, truncateTextStyle } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	root: {
		height: `100%`,
		overflow: `auto`,
	},
	accountActiveNumber: {
		color: success,
		fontSize: 42,
		fontWeight: 600,
	},
	accountListHeader: {
		color: '#a7abad',
		display: 'flex',
		fontSize: 11,
		paddingBottom: 10,
		paddingRight: 10,
		textTransform: 'uppercase',
	},
	accountListHeaderCompanyName: {
		color: darkGrayFontColor,
		flexGrow: 1,
		fontSize: 11,
		letterSpacing: 1.1,
		marginLeft: 40,
		textTransform: 'uppercase',
		width: 300,
	},
	accountListHeaderLast: {
		color: darkGrayFontColor,
		flexGrow: 0.3,
		fontSize: 11,
		letterSpacing: 1.1,
		marginLeft: 20,
		marginRight: 0,
		textTransform: 'uppercase',
		width: 80,
	},
	accountListHeaderStandard: {
		color: darkGrayFontColor,
		flexGrow: 0.5,
		fontSize: 11,
		letterSpacing: 1.1,
		marginLeft: 20,
		marginRight: 20,
		textTransform: 'uppercase',
		width: 80,
	},
	accountsTitle: {
		fontSize: 24,
		minWidth: 180,
	},
	accountsTitleHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		margin: '20px 0px',
	},
	accountTotalDesc: {
		color: darkGrayFontColor,
		display: 'inline-block',
		fontSize: 11,
		letterSpacing: 1.1,
		marginLeft: 10,
		textOverflow: 'wrap',
		textTransform: 'uppercase',
		width: 65,
	},
	accountTotalNumber: {
		color: brandPrimaryText,
		fontSize: 42,
		fontWeight: 600,
	},
	actionBarContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 20,
	},
	actionBarFilters: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
	},
	clearFilters: {
		color: brandPrimaryText,
		cursor: 'pointer',
		fontSize: 14,
		marginLeft: 20,
	},
	contentContainer: {
		paddingLeft: 4,
		paddingRight: 4,
		paddingTop: 30,
	},
	ctaButton: {
		height: 40,
	},
	exportButton: {
		alignItems: 'center',
		color: brandPrimaryText,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 14,
	},
	triggerContainer: {
		width: 260,
	},
	dropdownContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
	},
	dropdownContainerWithMargin: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		marginLeft: 20,
	},
	dropdownTrigger: {
		border: DefaultBorder,
		borderRadius: 3,
		color: header,
		maxWidth: 300,
		minWidth: 160,
		padding: 8,
		[BreakPoints.forMaxWidth(1024)]: {
			maxWidth: 250,
		},
		[BreakPoints.forMaxWidth(900)]: {
			width: 200,
		},
		...CssSelectors.allChildren(
			{
				...truncateTextStyle,
			},
			'.select-box-trigger-content'
		),
	},
	searchBarText: {
		color: '#858585',
		fontSize: 14,
		marginLeft: 20,
		marginRight: 10,
	},
	typeDropdown: {
		width: 160,
	},
	typeDropdownMenu: {
		minWidth: 160,
	},
	typeSelectTrigger: {
		width: 160,
	},
	selectTrigger: {
		width: 224,
	},
});
